import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { LOCAL__generation_set_current } from '@/state/generation/LOCAL__generation_set_current';
import { LOCAL__generation_set_generation_id_next } from '@/state/generation/LOCAL__generation_set_generation_id_next';
import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function WATCHER__generation_next() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const dispatch = use_dispatch();
  const navigate = useNavigate();
  const { toast } = useToast();

  const { g_graph__node_id_selected } = use_slice_ui(['g_graph__node_id_selected']);
  const { generation_next_id, generations_map } = use_slice_generation(['generation_next_id', 'generations_map']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (generation_next_id == ENUM__string_id_empty.OBJECT_ID) return; //no need to shift to next generation
    if (!generations_map.has(generation_next_id)) return; //not loaded yet

    toast({ title: t(i18n_base_ui.toasts.generation_next.title), duration: CONSTANTS_TIME__client.TIMEOUT_DURATION_GENERATION_NEXT_INFO_HIDE });

    void navigate(ENUM__page_type.BUILD_PATH_GENERATION(generation_next_id));

    dispatch(LOCAL__generation_set_current(generation_next_id));
    dispatch(LOCAL__generation_set_generation_id_next(ENUM__string_id_empty.OBJECT_ID));

    let generation_next = generations_map.get_or_assert(generation_next_id);

    if (!generation_next.tool.graph.nodes_map.has(g_graph__node_id_selected)) {
      let node_selected_id = generation_next.tool.graph.invocation_grid2d_view.meta.node_id;

      UTILS__graph_ui.node__select(node_selected_id);
    }
  }, [generation_next_id, generations_map]);

  return null;
}
